/* NecksLevel — native sale hero carousel.
   Replaces Replo's carousel runtime: scroll-snap track + arrows + dots. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-nl-track]');
    var prev = root.querySelector('[data-nl-prev]');
    var next = root.querySelector('[data-nl-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nl-dot]'));
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('.nl-sale__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function current() {
      return Math.round(track.scrollLeft / slideWidth());
    }

    function go(i) {
      track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) {
      next.addEventListener('click', function () {
        var max = track.querySelectorAll('.nl-sale__slide').length - 1;
        go(Math.min(max, current() + 1));
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-nl-dot'), 10) || 0);
      });
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = current();
          dots.forEach(function (dot, j) {
            dot.classList.toggle('is-active', i === j);
          });
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('.nl-sale').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
